import api from "../../../../services/axios";

export interface PlatformTenantSessionDto {
  sessionId: string;
  tenantId: string;
  tenantName: string;
  accessToken: string;
  expiresAtUtc: string;
  /** The tenant's canonical Admin role name — the session acts as this role, not as any
   *  specific real Admin user (there's no per-user impersonation target). */
  role: string;
  dataScope: string;
  activeContext: string;
  /** No real employee/guardian entity backs this session — always null. */
  activeDomainEntityId?: string | null;
  /** No real employee/guardian entity backs this session — always null. */
  domainType?: string | null;
  effectivePermissionKeys: string[];
  permissionVersion: number;
}

type ApiError = {
  code?: string | null;
  message?: string | null;
};

type ApiResponse<T> = {
  data?: T;
  meta?: { statusCode?: number; message?: string };
  errors?: ApiError[] | null;
};

function unwrapApiResponse<T>(payload: ApiResponse<T>): T {
  const firstError = payload?.errors?.[0]?.message;
  if (firstError) {
    throw new Error(firstError);
  }

  if (payload?.data === undefined) {
    throw new Error(payload?.meta?.message || "Unexpected API response");
  }

  return payload.data;
}

export async function startPlatformTenantSession(
  tenantId: string,
): Promise<PlatformTenantSessionDto> {
  const resp = await api.post<ApiResponse<PlatformTenantSessionDto>>(
    "/platform/tenant-sessions",
    { tenantId },
  );
  return unwrapApiResponse(resp.data);
}

export async function endPlatformTenantSession(): Promise<void> {
  await api.post<ApiResponse<null>>("/platform/tenant-sessions/end");
}
